import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Kronos admin module — `/kronos/*` on console.francisquini.ai.
 *
 * Six subroutes: home dashboard, pricing editor, subscriptions list +
 * detail, grants manager, and per-user detail (cross-link from User 360).
 *
 * Surface is `'admin'`; route builder mounts these only on the console
 * host. RequireAdmin gates inside each page (defence-in-depth).
 *
 * Spec: arkheus docs/cockpit/dashboards/tier-2-growth-monetizacao.md § 2.2.
 * Backend: francisquiniai/kronos PR #26 — admin endpoints at
 * `kronos.francisquini.ai/v1/admin/*`.
 */
export const manifest: ModuleManifest = {
  module_id: 'kronos',
  display_name: 'Kronos',
  surface: 'admin',
  routes: [
    {
      path: '/kronos',
      component: () =>
        import('@/routes/_app/kronos').then((m) => ({
          default: m.KronosHomePage,
        })),
      title: 'Kronos — Dashboard',
      permissions: [],
    },
    {
      path: '/kronos/pricing',
      component: () =>
        import('@/routes/_app/kronos').then((m) => ({
          default: m.KronosPricingPage,
        })),
      title: 'Kronos — Pricing',
      permissions: [],
    },
    {
      path: '/kronos/subscriptions',
      component: () =>
        import('@/routes/_app/kronos').then((m) => ({
          default: m.KronosSubscriptionsPage,
        })),
      title: 'Kronos — Subscriptions',
      permissions: [],
    },
    {
      path: '/kronos/subscriptions/$id',
      component: () =>
        import('@/routes/_app/kronos').then((m) => ({
          default: m.KronosSubscriptionDetailPage,
        })),
      title: 'Kronos — Subscription',
      permissions: [],
    },
    {
      path: '/kronos/grants',
      component: () =>
        import('@/routes/_app/kronos').then((m) => ({
          default: m.KronosGrantsPage,
        })),
      title: 'Kronos — Grants',
      permissions: [],
    },
    {
      path: '/kronos/users/$userId',
      component: () =>
        import('@/routes/_app/kronos').then((m) => ({
          default: m.KronosUserDetailPage,
        })),
      title: 'Kronos — Usuario',
      permissions: [],
    },
  ],
}
